import axios from "axios";

export const getMarcheArchivioApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + '/api/rfi/archivio/marche/', {
        params: params
    });
}

export const getMarcaArchivioByIdApi = (idMarcaArchivio, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/marche/${idMarcaArchivio}`, {
        params: params
    });
}

export const aggiungiMarcaArchivioApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/marche/`, payload, {
        params: params
    });
}

export const aggiornaMarcaArchivioApi = (idMarcaArchivio, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/marche/${idMarcaArchivio}`, payload, {
        params: params
    });
}

export const eliminaMarcaArchivioApi = (idMarcaArchivio, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/marche/${idMarcaArchivio}`, {
        params: params
    });
}

export const getTitoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/`,{
        params: params
    });
};

export const getTitoloByIdApi = (idTitolo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${idTitolo}`);
};

export const aggiornaTitoloApi = (idTitolo, payload, params = {}) => {
    // Sono obbligato ad utilizzare il verbo POST perché la PUT non accetta 'multipart/form-data'
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli-upd/${idTitolo}`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params: params
    });
}

export const aggiungiTitoloApi = (payload, params = {}) => {
    // Sono obbligato ad utilizzare il verbo POST perché la PUT non accetta 'multipart/form-data'
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/`, payload, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        params: params
    });
}

export const deleteTitoloApi = (idTitolo, filtri = '') => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${idTitolo}${filtri}`);
};

export const getTemiApi = (idTitolo) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${idTitolo}/temi/`);
};

export const getDocumentiArchivioApi = (idTitolo, idTema, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${idTitolo}/temi/${idTema}/documenti/`, {
        params: params
    });
};

export const getDocumentiArchivioAllApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/`, {
        params: params
    });
};

export const getDocumentoArchivioByIdApi = (idDocumento) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${idDocumento}`);
};

export const deleteDocumentoApi = (idDocumento, filtri = '') => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${idDocumento}${filtri}`);
};

export const updateDocumentoApi = (idDocumento, dati) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${idDocumento}`, dati);
};

export const aggiornaDocumentoArchivioApi = (idDocumento, dati) => {
    // Sono obbligato ad utilizzare il verbo POST perché la PUT non accetta 'multipart/form-data'
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/documenti/${idDocumento}`, dati, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
};
export const aggiungiDocumentoArchivioApi = (idArchivioTitolo, idArchivioTema, dati) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/archivio/titoli/${idArchivioTitolo}/temi/${idArchivioTema}/documenti/`, dati, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};
